'use strict';

// Import JS Modules
import React from 'react';
import { PandaView } from '../../../_utils/image-editor';

// -----------------------------------------------------------
//  PandaViewSimplePreview
// -----------------------------------------------------------
const PandaViewSimplePreview = (props) => {
  return (
    <PandaView { ...props }
               mode="preview"
               cropEdges />
  );
}

export default PandaViewSimplePreview;
